import { Modal, Timeline } from 'antd';
import React, { ReactElement, useState} from 'react';
import Text from 'antd/lib/typography/Text';
import { getDateWithTime } from '../../../../../../../utils/dateTimeUtils';

const CourierStatusTimeLine = (props: any): ReactElement => {

  const {
    courierStatus,
    courierTrackingHistory,
  } = props;
  const [isOpenModal, setIsOpenModal] = useState(false);

  const courierStatusClickHandler = (evt: any, isOpen: boolean): void => {
    evt.preventDefault();
    evt.stopPropagation();
    setIsOpenModal(isOpen);
  };

  return (
    <React.Fragment>
      <a
        onClick={(e: any): void => courierStatusClickHandler(e, true)}
      >
        {courierStatus}
      </a>
      <Modal
        visible={isOpenModal}
        footer={null}
        onCancel={(e: any): void => courierStatusClickHandler(e, false)}
        title={<h2>Courier Timeline</h2>}
      >
        <Timeline>
          {
            courierTrackingHistory?.map((ele: any, index: number): ReactElement => {
              return (index === 0) ? <Timeline.Item key={index}>
                <span className="selected-status">
                  <span className="bold">{ele?.status}
                  <p><Text type="secondary" className="fsize_sm">{ele?.location}</Text></p></span>
                  <span className="tab-space"> {getDateWithTime(ele?.statusDate)}</span>
                </span>
              </Timeline.Item> :
                <Timeline.Item>
                    <span className="bold">{ele?.status}<p><Text type="secondary" className="fsize_sm">{ele?.location}</Text></p>
                    </span><span className="tab-space"> {getDateWithTime(ele?.statusDate)}
                    </span>
                </Timeline.Item>;
            })
          }
        </Timeline>
      </Modal>
    </React.Fragment>
  );
};

export default CourierStatusTimeLine;
